import {useEffect, useState} from "react";
import role_types from "../assets/constants/roles";
import mailbox from "../assets/mailbox.svg";
import plane from "../assets/paper-plane.svg";
import envelope from "../assets/envelope-open.svg";
import link from "../assets/link.svg";
import info from "../assets/info-icon.png";


const SurveyParticipantsGridContainer = (props) => {
    const [people, setPeople] = useState([]);
    const [editor, setEditor] = useState(false);
    const updateSelected = props.updateSelected;
    const selectedPeople = props.selectedPeople;
    const newlySelected = props.newlySelected
    const updateNewlySelected = props.updateNewlySelected;
    const isNew = props.isNew;

    const [showHover, setShowHover] = useState(false)

    useEffect(() => {
        if(!props.editor) return;
        setEditor(props.editor)
    }, [props.editor])

    useEffect(() => {
        if(!props.people) return;
        setPeople(props.people)
    }, [props.people])

    useEffect(() => {
        if(!isNew || !people) return;

        let selected_list = []
        console.log(people)
        for(const person of people) {
            let selected = {"person_id": person.id, "name": person.name, "email": person.email, "completion_percentage": person.completion_percentage}
            selected_list.push(selected)
        }
        updateSelected(selected_list)
        updateNewlySelected(selected_list)
    }, [people]);

    const handleSelectAll = () => {
        if (!people) return;

        const allSelected = people.every(person => isSelected(person.id));

        if (allSelected) {
            // Untick everyone
            updateSelected([]);
            updateNewlySelected([]);
        } else {
            // Tick everyone
            const newSelected = people.map(person => ({
                person_id: person.id,
                name: person.name,
                email: person.email,
                completion_percentage: person.completion_percentage
            }));
            updateSelected(newSelected);
            updateNewlySelected(newSelected);
        }
    };

    const togglePerson = (id, name, email, completion_percentage) => {
        if (!id) return;
        if (!people) return;

        // If the person is to be removed show the yes/no dialog otherwise add them
        if (isSelected(parseInt(id))){
            let selected = [...selectedPeople];
            let index = selected.findIndex(x => x.person_id === parseInt(id))
            if (index > -1){
                // if it's in the array, remove it
                selected.splice(index,1);
            }
            updateSelected(selected);
            // check if in newlySelected array
            if (!newlySelected) return;
            let newly = [...newlySelected];
            let ind = newly.findIndex(x => x.person_id === parseInt(id))
            if (index > -1){
                // if it's in the array, remove it
                newly.splice(ind,1);
            }
            updateNewlySelected(newly);
        } else {
            let selected = [...selectedPeople];
            let newly = [...newlySelected];
            let index = selected.findIndex(x => x.person_id === parseInt(id))
            if (index < 0){
                let person = {}
                person.person_id = parseInt(id);
                person.name = name
                person.email = email
                person.completion_percentage = completion_percentage
                selected.push(person);
                newly.push(person);
            }
            updateSelected(selected);
            updateNewlySelected(newly);
        }
    }

    const isSelected = (id) => {
        let result = false;
        for (const person of selectedPeople) {
            if (person.person_id === id) {
                result = true;
                break;
            }
        }
        return result;
    }


    return (
        <>
            <div className="survey-participant-grid-container">
                <div className="survey-participant-grid-headers">
                    <div className="survey-participant-grid-include">
                        <input
                            type="checkbox"
                            id="masterCheckbox"
                            checked={people && people.every(person => isSelected(person.id))}
                            onChange={handleSelectAll}
                            disabled={!isNew && !editor}
                            style={{ marginRight: '8px' }}
                        />Included</div>
                    <div className="survey-participant-grid-name">Name</div>
                    <div className="survey-participant-grid-role">Role</div>
                    <div className="survey-participant-grid-email">Email</div>
                    {!isNew ?
                        <>
                            <div className="survey-participant-grid-email-status"
                                 title="The number of times an email has been sent. Please note the value may be slightly
                                 delayed.">
                                <img src={mailbox} alt="Mailbox icon"/>
                            </div>
                            <div className="survey-participant-grid-email-status"
                                 title="The number of times an email has been delivered. Please note the value may be
                                 slightly delayed.">
                                <img src={plane} alt="Paper plane icon"/>
                            </div>
                            <div className="survey-participant-grid-email-status"
                                 title="The number of times an email has been opened. Please note the value may be
                                 slightly delayed.">
                                <img src={envelope} alt="Envelope icon"/>
                            </div>
                            <div className="survey-participant-grid-email-status"
                                 title="The number of times an email has been clicked. Please note the value may be
                                 slightly delayed.">
                                <img src={link} alt="Chain icon"/>
                            </div>
                            <div className="survey-participant-grid-email-status info-popup">
                                <img src={info} alt="Info"
                                     onMouseOver={() => setShowHover(true)}
                                     onMouseLeave={() => setShowHover(false)}
                                />
                                {showHover ?
                                    <div className="survey-participant-grid-email-status-popup-container regular">
                                        <div className="survey-participant-grid-email-status-popup-triangle-outer">
                                            <div className="survey-participant-grid-email-status-popup-triangle"/>
                                        </div>
                                        <div className="survey-participant-grid-email-status-popup-text-image-container">
                                            <img src={mailbox} alt="Mailbox icon"/>
                                            This shows the number of times the email has been sent.
                                        </div>
                                        <br/><br/>
                                        <div className="survey-participant-grid-email-status-popup-text-image-container">
                                            <img src={plane} alt="Paper plane icon"/>
                                            This shows the number of times the recipients email exchange server has
                                            confirmed delivery (i.e the email address is valid). It does not mean it’s
                                            reached the recipients inbox as it could be in junk mail or held by some IT
                                            security software.
                                        </div>
                                        <br/><br/>
                                        <div className="survey-participant-grid-email-status-popup-text-image-container">
                                            <img src={envelope} alt="Envelope icon"/>
                                            This means the number of times the email has been opened – mostly by the
                                            recipient. Occasionally IT security software might open it once but several
                                            opens must be by the recipient.
                                        </div>
                                        <br/><br/>
                                        <div className="survey-participant-grid-email-status-popup-text-image-container">
                                            <img src={link} alt="Chain icon"/>
                                            Means the number of times the recipient has gone to the online survey
                                            webpage. This can only be the recipient clicking on the link to open up the
                                            survey.
                                        </div>
                                        <br/><br/>
                                        Percent Complete: means the percentage of the survey responses completed so
                                        far by the individual.
                                    </div> : null
                                }
                            </div>
                            <div className="survey-participant-grid-complete">Percent Complete</div>
                        </> : null
                    }
                </div>
                {people && people.map((person, idx) => {
                    return (
                        <div className="survey-participant-grid-row" key={idx}>
                            <div className="survey-participant-grid-include">
                                <input type="checkbox" checked={isSelected(person.id)}
                                       onChange={() => togglePerson(person.id, person.name, person.email, person.completion_percentage)}
                                       disabled={!isNew && !editor}/>
                            </div>
                            <div className="survey-participant-grid-name">{person.name}</div>
                            <div className="survey-participant-grid-role">{role_types.roles.find(x => x.id === person.role).name}</div>
                            <div className="survey-participant-grid-email">{person.email}</div>
                            {!isNew ?
                                <>
                                    <div className="survey-participant-grid-email-status">{person.sent || 0}</div>
                                    <div className="survey-participant-grid-email-status">{person.delivered || 0}</div>
                                    <div className="survey-participant-grid-email-status">{person.opened || 0}</div>
                                    <div className="survey-participant-grid-email-status">{person.clicked || 0}</div>
                                    <div className="survey-participant-grid-email-status info-popup">

                                    </div>
                                    <div className="survey-participant-grid-complete">
                                        <div className="perc-complete-container">
                                            <div className="perc-complete-filler"
                                                 style={{width: person.percentage_complete + "%"}}/>
                                            <div className="perc-complete-text">
                                                {person.percentage_complete ? person.percentage_complete + "%" : "0%"}
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                        </div>
                    )
                })}
            </div>
        </>
    )
}

export default SurveyParticipantsGridContainer